const REACT_APP_BFF_URL = process.env.REACT_APP_BFF_URL;

const buildHttpError = async (response, fallbackMessage) => {
    const errorData = await response.json().catch(() => ({}));
    const errorMessage = errorData.detail || fallbackMessage || `Error HTTP ${response.status}`;
    const error = new Error(errorMessage);
    error.status = response.status;
    error.detail = errorData.detail;
    return error;
};

export const createUser = async (uid, username, email, cuit, company, role) => {
    try {
        const response = await fetch(`${REACT_APP_BFF_URL}/users`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                uid: uid,
                username: username,
                company: company,
                cuit: cuit,
                email: email,
                role: role
            }),
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            const errorMessage = errorData.detail || `Error HTTP ${response.status}`;
            
            // Lanzar errores específicos según el código de estado
            if (response.status === 409) {
                throw new Error(`Usuario ya existe: ${errorMessage}`);
            } else if (response.status === 400) {
                throw new Error(`Datos inválidos: ${errorMessage}`);
            } else if (response.status >= 500) {
                throw new Error(`Error del servidor: ${errorMessage}`);
            } else {
                throw new Error(`Error al crear el usuario: ${errorMessage}`);
            }
        }

        return await response.json();
        
    } catch (error) {
        // Si es un error de red o parsing
        if (error.name === 'TypeError' || error.message.includes('fetch')) {
            throw new Error('Error de conexión con el servidor. Verifica tu conexión a internet.');
        }
        // Re-lanzar otros errores
        throw error;
    }
};
  
export const getAllUsers = async (token) => {
    try {
      const response = await fetch(`${REACT_APP_BFF_URL}/users/all`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`, // Suponiendo que usas un token para autenticar
        },
      });
  
      if (!response.ok) {
        throw new Error("Error fetching users");
      }
  
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error fetching users:", error);
      throw error;
    }
  };
  
  export const updateUserStatus = async (uid, token) => {
    try {
        const response = await fetch(`${REACT_APP_BFF_URL}/users/${uid}/update-status`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        });

        if (!response.ok) {
            throw new Error("Error updating user status");
        }

        return await response.json();
    } catch (error) {
        console.error("Error updating user status:", error);
        throw error;
    }
};

// Obtener el estado 'active' del usuario
export const getUserStatus = async (token) => {
  try {
      const response = await fetch(`${REACT_APP_BFF_URL}/users/status`, {
          method: "GET",
          headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
          },
      });

      if (!response.ok) {
          throw await buildHttpError(response, "Error fetching user status");
      }

      const data = await response.json();
      return data.active; // Devuelve el valor de active (true o false)
  } catch (error) {
      console.error("Error fetching user status:", error);
      throw error;
  }
};

export const getUserTermsAccepted = async (token) => {
    try {
      const response = await fetch(`${REACT_APP_BFF_URL}/users/terms`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
  
      if (!response.ok) {
        throw await buildHttpError(response, "Error fetching user terms acceptance status");
      }
  
      const data = await response.json();
      return data.termsAccepted; // Asegúrate de que esta propiedad exista en tu backend
    } catch (error) {
      console.error("Error fetching user terms acceptance status:", error);
      throw error;
    }
  };
  
  export const acceptUserTerms = async (token) => {
    try {
      const response = await fetch(`${REACT_APP_BFF_URL}/users/terms`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ termsAccepted: true }),
      });
  
      if (!response.ok) {
        throw new Error("Error al registrar la aceptación de términos");
      }
  
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error al registrar la aceptación de términos:", error);
      throw error;
    }
  };
  
